namespace RioERP.Shipping {
    export interface ShippingProvidersRow {
        Id?: number;
        ShippingProviderName?: string;
        Description?: string;
        BankName?: string;
        BankAccountNo?: string;
        BankIfscCode?: string;
        TrackingUrl?: string;
        EApiStatus?: Web.Enums.ShippingApiStatus;
        Gstin?: string;
        Pan?: string;
        GstCertificate?: string;
        Secret?: string;
        TrackingId?: string;
        IsActive?: boolean;
        VendorId?: number;
        EShippingProviderType?: Web.Enums.ShippingProviderType;
        IsDefault?: boolean;
        VendorName?: string;
        VendorDescription?: string;
        VendorBankName?: string;
        VendorBankAccountType?: number;
        VendorBankAccountName?: string;
        VendorBankAccountNo?: string;
        VendorBankIfscCode?: string;
        VendorAddress?: string;
        VendorCity?: string;
        VendorStateId?: number;
        VendorCountry?: string;
        VendorGstin?: string;
        VendorPan?: string;
        VendorGstCertificate?: string;
        VendorUserId?: number;
        VendorPincode?: number;
        VendorIsActive?: boolean;
        VendorInsertUserId?: number;
        VendorInsertDate?: string;
        VendorUpdateUserId?: number;
        VendorUpdateDate?: string;
        VendorEmail?: string;
        InsertUserId?: number;
        InsertDate?: string;
        UpdateUserId?: number;
        UpdateDate?: string;
    }

    export namespace ShippingProvidersRow {
        export const idProperty = 'Id';
        export const nameProperty = 'ShippingProviderName';
        export const localTextPrefix = 'Shipping.ShippingProviders';
        export const lookupKey = 'Shipping.ShippingProviders';

        export function getLookup(): Q.Lookup<ShippingProvidersRow> {
            return Q.getLookup<ShippingProvidersRow>('Shipping.ShippingProviders');
        }
        export const deletePermission = 'Shipping:ShippingManagement:Modify';
        export const insertPermission = 'Shipping:ShippingManagement:Modify';
        export const readPermission = 'Shipping:ShippingManagement:View';
        export const updatePermission = 'Shipping:ShippingManagement:Modify';

        export declare const enum Fields {
            Id = "Id",
            ShippingProviderName = "ShippingProviderName",
            Description = "Description",
            BankName = "BankName",
            BankAccountNo = "BankAccountNo",
            BankIfscCode = "BankIfscCode",
            TrackingUrl = "TrackingUrl",
            EApiStatus = "EApiStatus",
            Gstin = "Gstin",
            Pan = "Pan",
            GstCertificate = "GstCertificate",
            Secret = "Secret",
            TrackingId = "TrackingId",
            IsActive = "IsActive",
            VendorId = "VendorId",
            EShippingProviderType = "EShippingProviderType",
            IsDefault = "IsDefault",
            VendorName = "VendorName",
            VendorDescription = "VendorDescription",
            VendorBankName = "VendorBankName",
            VendorBankAccountType = "VendorBankAccountType",
            VendorBankAccountName = "VendorBankAccountName",
            VendorBankAccountNo = "VendorBankAccountNo",
            VendorBankIfscCode = "VendorBankIfscCode",
            VendorAddress = "VendorAddress",
            VendorCity = "VendorCity",
            VendorStateId = "VendorStateId",
            VendorCountry = "VendorCountry",
            VendorGstin = "VendorGstin",
            VendorPan = "VendorPan",
            VendorGstCertificate = "VendorGstCertificate",
            VendorUserId = "VendorUserId",
            VendorPincode = "VendorPincode",
            VendorIsActive = "VendorIsActive",
            VendorInsertUserId = "VendorInsertUserId",
            VendorInsertDate = "VendorInsertDate",
            VendorUpdateUserId = "VendorUpdateUserId",
            VendorUpdateDate = "VendorUpdateDate",
            VendorEmail = "VendorEmail",
            InsertUserId = "InsertUserId",
            InsertDate = "InsertDate",
            UpdateUserId = "UpdateUserId",
            UpdateDate = "UpdateDate"
        }
    }
}
